import { AbstractControl, FormGroup, ValidationErrors } from "@angular/forms";
import { cnpj, cpf } from "cpf-cnpj-validator";
import { CnpjValidator } from './cnpj-validator';

export function cpfValidator(
  control: AbstractControl
): ValidationErrors | null {
  const value = control.value;

  const cleanedCpf = value.replace(/\D/g, ""); // Remove caracteres não numéricos

  if (!cpf.isValid(cleanedCpf)) return { cpfInvalid: true };

  return null; // CPF válido
}

export function cnpjValidator(
  control: AbstractControl
): ValidationErrors | null {
  const value = control.value;
  if (!value) return null;

  if (!CnpjValidator.isValid(value)) return { cnpjInvalid: true };

  return null; // CPF válido
}

export function emailValidator(
  control: AbstractControl
): ValidationErrors | null {
  const emailRegex = /^[A-Za-z0-9._+-]+@[A-Za-z0-9.-]+\.[A-Za-z]{2,}$/;
  const email = control.value;

  if (!email) {
    return null;
  };

  return emailRegex.test(email) ? null : { emailInvalid: true };
}

export function emailConfirmValidator(
  form: FormGroup
): ValidationErrors | null {
  const email = form.get("email")?.value;
  const confirmaEmail = form.get("confirmaEmail")?.value;
  const confirmaEmailControl = form.get("confirmaEmail");

  if (!confirmaEmail) return null;

  const errors = { ...(confirmaEmailControl?.errors || {}) };

  if (email !== confirmaEmail) {
    confirmaEmailControl?.setErrors({ ...errors, emailsDiferentes: true });
    return { emailsDiferentes: true };
  } else {
    delete errors.emailsDiferentes;
    confirmaEmailControl?.setErrors(Object.keys(errors).length ? errors : null);
    return null;
  }
}

export function passwordValidator(
  control: AbstractControl
): ValidationErrors | null {
  const senha = control.value;

  if (!senha) return { invalidPassword: true };

  // Expressão regular para validar a senha forte
  const senhaForteRegex = /^[a-zA-Z0-9!@#$%\^&*(),.?":{}|<>]*/;

  if (!senhaForteRegex.test(senha)) return { weakPassword: true };

  return null; // Senha válida
}

export function passwordConfirmValidator(
  form: FormGroup
): ValidationErrors | null {
  const senha = form.get("senha")?.value;
  const confirmarSenha = form.get("confirmaSenha")?.value;

  if (senha && !confirmarSenha) return { confirmPasswordRequired: true };

  if (senha !== confirmarSenha) {
    form.get('confirmaSenha')?.setErrors({ ...form.get('confirmaSenha')?.errors, senhasDiferentes: true });
    return { senhasDiferentes: true };
  } else {
    const errors = form.get('confirmaSenha')?.errors;
    if (errors) {
      delete errors.senhasDiferentes;
      form.get('confirmaSenha')?.setErrors(Object.keys(errors).length ? errors : null);
    }
  }
  return null; // Senhas são iguais
}

export function termsValidator(
  control: AbstractControl
): ValidationErrors | null {
  if (!control.value) return { termNotAccepted: true };

  return null; // Termo aceito
}

export function validateTelOrCell(form: FormGroup): ValidationErrors {
  const tel = form.get("telefone")?.value;
  const cell = form.get("celular")?.value;

  if (!tel && !cell) {
    return { telOrCellRequired: true };
  }

  return null;
}
